module.exports = __webpack_public_path__ + "img/fitnessField.1e28b267.png";